import * as React from "react"

export const GENERAL_CONTENT = {
    en: {
        name: "St. John the Baptist Ukrainian Catholic Church",
        pastor: "Rev. Stepan Bilyk",
        pastorLabel: "Pastor",
        support: "Support Our Church",
        moreDetails: "Show More",
        lessDetails: "Show Less",
        UACCNJ: "Ukrainian-American Cultural Center NJ",
        UCAP: "Ukrainian Catholic Archeparchy of Philadelphia",
        UCAP_LABEL: <center>Ukrainian Catholic <br /> Archeparchy of Philadelphia</center>,
        UGCC: "Ukrainian Greek Catholic Church",
        UGCC_LABEL: <center>Ukrainian Greek Catholic Church</center>,
        the: 'The ',
        and: "and",
        and_or: "and/or",
        showDetails: "See Details",
        download: "Download",
        print: "Print",
        ugcc_url: "https://ugcc.ua/en/",
        DYVENSVIT: "Dyven Svit",
        DYVENSVIT_LABEL: <center>Dyven Svit</center>,
        home: "Home",
    },
    ua: {
        name: "Українська Католицька Церква Св. Івана Хрестителя",
        pastor: "О. Степан Білик",
        pastorLabel: "Парох",
        support: "Підтримати Церкву",
        moreDetails: "Показати Більше",
        lessDetails: "Показати Менше",
        UACCNJ: "Українсько-Aмериканський Культурний Центр NJ",
        UCAP: "Українська Католицька Архиєпархія Філадельфії",
        UCAP_LABEL: <center>Українська Католицька<br /> Архиєпархія Філадельфії</center>,
        UGCC: "Українська Греко Католицька Церква",
        UGCC_LABEL: <center>Українська Греко Католицька Церква</center>,
        the: '',
        and: "та",
        and_or: "та/або",
        showDetails: "Побачити Більше Деталей",
        download: "Завантажити",
        print: "Друкувати",
        ugcc_url: "https://ugcc.ua/",
        DYVENSVIT: "Дивен Світ",
        DYVENSVIT_LABEL: <center>Дивен Світ</center>,
        home: "Додому",
    }
}